import { Dialog, DialogContent, DialogTitle, Divider, List, 
    ListItem, Stack, Typography } from "@mui/material";
import * as ATCAConstants from '../util/ATCAConstants'
import React from "react";

export default function BandInfoDialog(
  props: {
    open: boolean,
    handleClose: () => void,
  }
) {
    return (

        <Dialog maxWidth='md' fullWidth
        aria-labelledby="receiver-dialog-title"
        onClose={ e => props.handleClose() } 
        open={props.open}
        >
        <DialogTitle id="receiver-dialog-title">
            ATCA Receivers
        </DialogTitle>
        
        <DialogContent>
            <Typography variant="body1" gutterBottom>
            There are {ATCAConstants.NUMBER_OF_IF} bands of width {ATCAConstants.IF_BAND_WIDTH} MHz. 
            Except 16cm receiver which has one band.
            </Typography>
            <List sx={{ pt: 0 }}>
                <ListItem key={`receiver-title`} sx={{ textAlign: 'center' }}>
                    <Typography variant="body1" width={'100px'}>
                    Receiver
                    </Typography>
                    <Typography variant="body1" width={'200px'}>
                    Receiver Range (MHz)
                    </Typography>
                    <Typography variant="body1" 
                    sx={{ textAlign: 'center', flexGrow: 4 }}>
                    Centre Frequency
                    </Typography>
                </ListItem>
                {
                ATCAConstants.ReceiverRange.map((receiver) =>(
                    <React.Fragment>
                        <Divider variant="inset" component="li" sx={{ marginLeft: 0}}/>
                        <ListItem key={`receiver-${receiver.name}`} 
                            sx={{ textAlign: 'center'}}>
                            <Typography variant="body2" width={'100px'}>
                                {receiver['name']}:
                            </Typography>
                            <Typography variant="body2" width={'200px'}>
                                {receiver.start.toLocaleString()} - {receiver.end.toLocaleString()}
                            </Typography>
                                {
                                    ATCAConstants.ReceiverDescription[receiver['name']] &&
                                    <Stack direction={'column'} flexGrow={4}>   
                                        <Typography variant="body2">
                                            {ATCAConstants.ReceiverDescription[receiver['name']][0]}
                                        </Typography>
                                        <Typography variant="body2">
                                            {ATCAConstants.ReceiverDescription[receiver['name']][1]}
                                        </Typography>
                                    </Stack>
                                }
                        </ListItem>
                    </React.Fragment>
                ))
                }
        </List>
        </DialogContent>
        </Dialog>
    );
}

